import { FC } from 'react';
import FlexPage from '../components/atoms/FlexPage';
import FlexContent from '@/components/atoms/FlexContent';
import FullPageDropOverlay from '../components/atoms/FullPageDropOverlay';
import { DropHint } from '../components/extract';
import Navb from '../components/Navb';
import HomePageContent from '../components/home';
import useFileDrop from '../use/useFileDrop';

const HomePage: FC = () => {
  const {
    dropDisabled,
    pdfsOpenInIntake,
    validDropExtensions,
    handleDrop,
    handleFileBrowse,
  } = useFileDrop();

  return (
    <FlexPage>
      <Navb />
      <FullPageDropOverlay
        validExtensions={validDropExtensions}
        onDrop={([file]) => (file ? handleDrop(file) : undefined)}
        disabled={dropDisabled}
      >
        <FlexContent>
          <HomePageContent />
        </FlexContent>
      </FullPageDropOverlay>
      <DropHint
        onFileBrowse={handleFileBrowse}
        validExtensions={validDropExtensions}
        importDisabled={dropDisabled}
        pdfsOpenInIntake={pdfsOpenInIntake}
      />
    </FlexPage>
  );
};

export default HomePage;
